"use strict";

export class Link {
  constructor() {}
}
